import { z } from 'zod';

export const schemaChatMessageReadPayload = z.object({
    metaMessageId: z.string().min(1),
});

export type Schema_ChatMessageReadPayload = z.infer<typeof schemaChatMessageReadPayload>;
